import { Container } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Button from "../../common/components/Button";
import PageHeader from "../../common/components/PageHeader";
import { duplicateProject, getMyProjects, switchProject } from "../api/project";
import CreateNewProjectCard from "../components/CreateNewProjectCard";
import ProjectCard from "../components/ProjectCard";

function MyProjects() {
  const { t } = useTranslation("projects");
  const [projects, setProjects] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const fetchedProjects = await getMyProjects();
        setProjects(fetchedProjects);
      } catch (error) {
        console.error("Error fetching :", error);
      }
    };

    fetchProjects();
  }, []);

  const handleSwitchProject = async (project_id) => {
    try {
      await switchProject(project_id);
      window.location.href = "/";
    } catch (error) {
      console.error("Error switching project:", error);
    }
  };

  const handleDuplicate = async (project_id) => {
    try {
      await duplicateProject(project_id);
      // Refresh the projects list after duplication
      const fetchedProjects = await getMyProjects();
      setProjects(fetchedProjects);
    } catch (error) {
      console.error("Error duplicating project:", error);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 10 }}>
      <PageHeader
        title={t("myProjects.title")}
        description={t("myProjects.description")}
        appendActions={
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate("/projects/create");
            }}
          >
            <Plus size={18} className="me-2" /> {t("myProjects.create")}
          </Button>
        }
      />

      <Grid container spacing={4} sx={{ display: "flex", pb: 5 }}>
        <CreateNewProjectCard />
        {projects.map((project) => (
          <ProjectCard
            project={project}
            key={project.id}
            handleSwitchProject={handleSwitchProject}
            handleDuplicate={handleDuplicate}
          />
        ))}
      </Grid>
    </Container>
  );
}

export default MyProjects;
